import { Navigate } from "react-router-dom";
import useAuth from "@/hooks/useAuth";

interface Props {
  children: React.ReactNode;
}

const SuperAdminRoute: React.FC<Props> = ({ children }) => {
  const { authUser } = useAuth();

  if (authUser?.role === "superadmin") {
    return children;
  }

  return <Navigate to="/admin" replace />;
};

export default SuperAdminRoute;
